<template>
  <div>
    <div class="cpt_choose_place" :style="{ '--lineHeight': height * 0.5 + 'px' }">
      <div class="text-wrap" :style="textWrapStyle">
        {{ iptVal }}
      </div>
      <div class="img-wrap" :style="imgWrapStyle">
        <t-image @click="handleClick" style="width: 100%; height: 100%; z-index: 0"
          :style="{ backgroundColor: option.attribute.imgBgColor || 'none' }"
          :src="option.attribute.url ? fileUrl + option.attribute.url : require('@/assets/custom/choose_place.png')"
          :fit="option.attribute.fit" />
      </div>
    </div>
    <t-drawer :attach="'body'" v-model:visible="visible" size="100%" header="" :footer="false" :close-btn="false">
      <div style="height: 100%">
        <div id="l-map" ref="lmap"></div>
        <div id="input_content">
          <div id="r-result">
            <div class="map_input_box">
              <input type="text" placeholder="搜索地点" id="suggestId" size="20" v-model="suggestValue" class="map_input" />
              <t-image @click="clearConcent"
                style="width: 4%; position: absolute; cursor: pointer; right: 10px; top: 12px"
                :src="require('@/assets/custom/close.png')" fit="fill" />
            </div>
            <div class="map_btn" @click="handClose">完成</div>
          </div>
          <div id="searchResultPanel" style="border: 1px solid #c0c0c0; width: 150px; height: auto; display: none">
          </div>
        </div>
      </div>
    </t-drawer>
  </div>
</template>

<script>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { fileUrl } from "/env";
import loadBMap from "@/utils/baiduMap.js"; //单个文件加载百度地图
export default {
  name: "cpt-choose-place",
  props: {
    option: Object,
    current: Object,
    components: Array,
    height: Number,
    refMap: Object,
  },
  data() {
    return {
      uuid: null,
      map: null,
      geolocation: null,
      localSearch: null,
      iptVal: "",
      newData: "",
      jsFunFlag: false,
      visible: false,
      suggestValue: "",
      mapGps: "",
      mapAddredd: "",
      fileUrl,
    };
  },
  computed: {
    textWrapStyle() {
      const attr = this.option.attribute;
      return {
        color: attr.textColor,
        fontStyle: attr.fontStyle,
        fontWeight: attr.fontWeight,
        fontFamily: attr.fontFamily,
        fontSize: attr.fontSize + "px",
        lineHeight: this.height * 0.5 + "px",
      };
    },
    imgWrapStyle() {
      const attr = this.option.attribute;
      return {
        animation: attr.autoRotate ? "rotate " + attr.rotateDuration + "s infinite linear" : null,
        width: attr.width + "px",
        height: attr.height + "px",
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    "option.attribute": {
      handler() {
        this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  async mounted() {
    await this.loadBaiduMap();
    this.initMap();

  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
    // 显示GPS
    if (Array.isArray(this.current.group) && this.current.group.length > 0) {
      if (Array.isArray(this.components) && this.components.length > 0) {
        this.components.forEach((item) => {
          if (this.current.group.includes(item.id) && item.cptKey === "cpt-text") {
            item.cptShow = this.option.attribute.showGPS;
          }
        });
      }
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm, paras));
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData = cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction") ? res.resStr : res;
        that.jsFunFlag = cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction") ? res.jsFunction : false;
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag) {
      if (cptDataForm.dataSource == "4") {
        if (jsFunFlag) {
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.iptVal = newres[0].value;
          }
        } else {
          this.iptVal = res.value;
        }
      } else {
        this.iptVal = res.value;
      }


    },
    initMap() {
      let centerx = this.option.attribute.centerx;
      let centery = this.option.attribute.centery;
      let zoom = this.option.attribute.zoom;
      const mapContainer = this.$refs.lmap;
      this.map = new BMapGL.Map(mapContainer);
      this.geolocation = new BMapGL.Geolocation()
      this.map.centerAndZoom(new BMapGL.Point(centerx, centery), zoom); // 初始化中心点和缩放
      this.map.enableScrollWheelZoom(true);
      this.localSearch = new BMapGL.LocalSearch(this.map, {
        onSearchComplete: this.onSearchComplete,
      });
      this.setupAutocomplete();
      let that = this;
      // 点击标记点
      this.map.addEventListener("click", function (e) {
        that.map.clearOverlays();
        let point = new BMapGL.Point(e.latlng.lng, e.latlng.lat);
        let marker = new BMapGL.Marker(point);
        that.map.addOverlay(marker);
        /**
         * @title 2025/5/19 因百度地图配额逆向解析地址上限  去除当前代码
         */
        // var geoc = new BMapGL.Geocoder();
        // geoc.getLocation(point, function (rs) {
        //   console.log('wdqqdwqqwdqwwqd', rs);
        //   let address = rs.content.poi_desc;
        //   that.suggestValue = address;
        //   that.mapGps = rs.point;
        //   console.log(rs, "rs");
        //   // rs.content.address_detail
        //   // content.address_detail.province
        //   // content.address_detail.city

        //   // content.address_detail.town
        //   // content.address_detail.street
        //   that.mapAddredd = rs.content.address_detail.district + rs.content.poi_desc;
        // });
      });
    },
    //建立一个自动完成的对象,需要绑定输入框的id,及地图对象
    setupAutocomplete() {
      var ac = new BMapGL.Autocomplete({
        input: "suggestId",
        location: this.map,
      });
      ac.addEventListener("onhighlight", (e) => { });
      ac.addEventListener("onconfirm", (e) => {
        //鼠标点击下拉列表后的事件
        this.suggestValue = e.item.value.business;
        this.setPlace();
      });
    },
    setPlace() {
      this.map.clearOverlays();
      this.localSearch.search(this.suggestValue);
    },
    // 点击 定位图片 打开抽屉
    handleClick() {
      if (this.$route.name != "design") {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
    // 搜索框 x 号
    clearConcent() {
      this.suggestValue = "";
    },

    onSearchComplete(results) {
      var pp = results.getPoi(0).point;
      this.map.centerAndZoom(pp, 18);
      this.map.clearOverlays();
      this.map.addOverlay(new BMapGL.Marker(pp));
      this.mapGps = pp;
      console.log(results, "*");
      this.mapAddredd = results.getPoi(0).title;
    },
    // 完成按钮
    handClose() {
      let that = this;
      this.visible = false;
      this.iptVal = that.mapAddredd;
      let data = that.mapGps.lng.toFixed(6) + "," + that.mapGps.lat.toFixed(6); // 经纬度
      this.setTextValue(data);
    },
    //  组合控件赋值
    setTextValue(val) {
      if (val != "") {
        if (Array.isArray(this.current.group) && this.current.group.length > 0) {
          if (Array.isArray(this.components) && this.components.length > 0) {
            this.components.forEach((item) => {
              if (this.current.group.includes(item.id) && item.cptKey === "cpt-text") {
                // 显示GPS 如果隐藏了gps，refMap就不会返回这个控件所有的方法。就找不到。就需要换种方法来赋值
                if (this.refMap[item.id] != null) {
                  this.refMap[item.id].setValue(val);
                } else {
                  console.log(this.components, "components");
                  item.cptOption.cptDataForm.dataText = `{"value": "${val}"}`;
                }
              }
            });
          }
        }
      }
    },

    setValue(value) {
      // 赋值
      this.iptVal = value;
    },
    getValue() {
      // 获取值
      return this.iptVal;
    },
    async loadBaiduMap() {
      await loadBMap("7fFqz1bKk5DPlq2GIXr4bOLCUgKyyXID"); // 替换为实际的AK值
    },
  },
};
</script>

<style scoped>
.cpt_choose_place {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.text-wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
}

.img-wrap {
  position: relative;
  top: calc(var(--lineHeight) * 0.5);
  transform: translateY(-50%);
  cursor: pointer;
}

#input_content {
  position: absolute;
  top: 30px;
  z-index: 999;
  left: 2%;
}

.map_input_box {
  position: relative;
  display: flex;
  width: 85%;
}

.map_input {
  width: 100%;
  height: 35px;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 5px;
  padding-left: 10px;
}

.map_btn {
  width: 10%;
  height: 35px;
  background-color: #2589ff;
  line-height: 35px;
  text-align: center;
  border-radius: 5px;
  margin-left: 10px;
  color: #fff;
  cursor: pointer;
}

#l-map {
  height: 100%;
  width: 100%;
}

#r-result {
  width: 375px;
  display: flex;
}

:deep(.tangram-suggestion-main) {
  z-index: 100000 !important;
}

:deep(.tangram-suggestion) {
  z-index: 100000 !important;
}

.t-image__wrapper {
  background: none !important;
}

:deep(.t-drawer__body) {
  padding: 0 0 !important;
}

:deep(.t-drawer__footer) {
  padding: 0 0 !important;
}

:deep(.t-drawer__close-btn .t-icon) {
  font-size: 25px;
}

:deep(.t-drawer__close-btn) {
  z-index: 10000;
}

:deep(.t-drawer__close-btn) {
  background: none;
  color: #000;
  position: absolute;
  right: 2rem;
  opacity: 0.3;
  font-weight: bold;
  top: 0rem;
}

:deep(.t-drawer__close-btn:hover) {
  background: none;
  color: #000;
  position: absolute;
  right: 2rem;
  opacity: 0.4;
  font-weight: bold;
  top: 0rem;
}
</style>
